import { PageRouteBuilder } from "@common/route/page-route-builder";
import { LandingPageComponent } from "./landing-page.component";

export const landingPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-landing-page", LandingPageComponent)
    .atUrl("/welcome")
    .withTitle("Welcome")
    .build();
